import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["accept"]
const _hoisted_2 = ["accept"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.compact)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: _normalizeClass(["btn", _ctx.buttonClass]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.input?.click())),
        onDragenter: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.highlight && _ctx.highlight(...args))),
        onDragover: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.highlight && _ctx.highlight(...args))),
        onDragleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.unHighlight && _ctx.unHighlight(...args))),
        onDrop: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
      }, [
        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "fas fa-plus me-1" }, null, -1)),
        _createTextVNode(" " + _toDisplayString(_ctx.buttonLabel) + " ", 1),
        _createElementVNode("input", {
          type: "file",
          class: "d-none",
          ref: "input",
          multiple: "",
          accept: _ctx.acceptedTypes.join(','),
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileInputChange && _ctx.onFileInputChange(...args))),
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, null, 40, _hoisted_1)
      ], 34))
    : (_openBlock(), _createElementBlock("label", {
        key: 1,
        class: _normalizeClass(["file-picker-zone card shadow-sm text-center p-5 m-0 d-block form-label", {'border-info': _ctx.highlighted}]),
        onDragenter: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.highlight && _ctx.highlight(...args))),
        onDragover: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.highlight && _ctx.highlight(...args))),
        onDragleave: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.unHighlight && _ctx.unHighlight(...args))),
        onDrop: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
      }, [
        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "fas fa-images fa-2x text-muted mb-3 d-block mx-auto" }, null, -1)),
        _renderSlot(_ctx.$slots, "default"),
        _createElementVNode("input", {
          type: "file",
          class: "d-none",
          multiple: "",
          accept: _ctx.acceptedTypes.join(','),
          onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onFileInputChange && _ctx.onFileInputChange(...args)))
        }, null, 40, _hoisted_2)
      ], 34))
}